<template>
  <div>
    <header>
      <Header />
    </header>
    <div>
      <div id="main">
        <section class="updateInfo">
          <div class="updateInfoTitle">
            <div class="inner4">
              <h1>アップデート情報</h1>
              <p class="titleSub">Update Information</p>
            </div><!-- /inner4-->
          </div><!-- /updateInfoTitle-->

          <div class="updateInfoBody">
            <section class="updateBlock" v-if="!this.checkOpenExhibition()">
              <div class="inner2">
                <h2>2021年12月12日：「東京カメラ部2021写真展 Online Exhibition」閉幕いたしました</h2>
                <div class="updateBlockInner">
                  <p class="updateMessage">
                  「東京カメラ部2021写真展 Online Exhibition」へ多くのアクセスをいただき、誠にありがとうございました。本写真展は2021年12月11日をもって終了しました。<br>
                  写真展終了に伴い「応援メッセージ・感想」へのコメント受付は終了となります。 今までに皆様から寄せられたコメントや、展示作品、ポートフォリオについては引き続き閲覧可能です。オンライントークショーについてもアーカイブ動画やレポートページを用意していますので、引き続き本サイトをお楽しみください。
                  </p>
                </div>
              </div><!-- /inner2-->
            </section><!-- /updateBlock-->

            <section class="updateBlock">
              <div class="inner2">
                <h2>2021年12月3日：協賛団体展示の美瑛町展示ページにて「石川由依」さんによる音声ガイドコンテンツを公開しました</h2>
                <div class="updateBlockInner">
                  <p class="updateMessage">人気声優「石川由依」さんの音声ガイドを聞きながら、美瑛町の四季折々の写真とともに美瑛町の魅力的なフォトスポットをめぐるツアー「カメラと旅する北海道・美瑛町」の公開に伴い、東京カメラ部2021写真展 協賛団体展示内の美瑛町展示ページでも「石川由依」さんによる音声ガイドコンテンツを公開しました。ぜひ、お聞きください。<br>
                  <router-link to="/sponsors/600003">東京カメラ部2021写真展、美瑛町展示ページはこちら</router-link>
                  </p>
                </div>
              </div><!-- /inner2-->
            </section><!-- /updateBlock-->

            <section class="updateBlock">
              <div class="inner2">
                <h2>2021年11月30日：協賛団体展示の岐阜市展示ページにて「梶裕貴」さんによる音声ガイドコンテンツを公開しました</h2>
                <div class="updateBlockInner">
                  <p class="updateMessage">人気声優「梶裕貴」さんの音声ガイドを聞きながら、美しい写真とともに岐阜市の魅力的なフォトスポットをめぐる街歩きツアー Voice Guide「カメラと旅する岐阜市」公開に伴い、東京カメラ部2021写真展 協賛団体展示内の岐阜市展示ページでも「梶裕貴」さんによる音声ガイドコンテンツを公開しました。
                    岐阜市の魅力的なフォトスポットや、写真の撮り方のコツなどを紹介しています。ぜひ、お聞きください。<br>
                  <router-link to="/sponsors/600007">東京カメラ部2021写真展、岐阜市展示ページはこちら</router-link>
                  </p>
                </div>
              </div><!-- /inner2-->
            </section><!-- /updateBlock-->

            <section class="updateBlock">
              <div class="inner2">
                <h2>2021年11月19日：東京カメラ部2021写真展メッセージ完全版「梶裕貴・石川由依」篇 を公開しました。</h2>
                <div class="updateBlockInner">
                  <p class="updateMessage">２年連続でオンライン開催となってしまった今年はその想いを、より広く、より深く皆様にお伝えするために動画を作成いたしました。また、その動画のナレーションには実力、人気を兼ね備えた梶裕貴さんと石川由依さんのお二人にお願いをしました。<br>
                  今回はお二人の掛け合いという形で、東京カメラ部2021写真展メッセージ完全版をお届けさせていただきます。出展者の皆様は当然のこと、少しでも多くの方にこのメッセージが届くことを願っています。<br>
                  <router-link to="/about">東京カメラ部2021写真展メッセージはこちら</router-link>
                  </p>
                </div>
              </div><!-- /inner2-->
            </section><!-- /updateBlock-->

            <section class="updateBlock">
              <div class="inner2">
                <h2>2021年11月15日：東京カメラ部Twitterフォトコンテスト受賞作品を発表しました。</h2>
                <div class="updateBlockInner">
                  <p class="updateMessage">2021年08月16日 ～ 2021年09月14日に開催した「東京カメラ部Twitterフォトコンテスト ～写真で表現するあなたの世界～」の受賞作品が追加公開されました！<br>
                    合計3部門、30名分の受賞作品を展示しています。<br>
                    街なかで見つけた何気ない景色や、身の回りで起きた一瞬の出来事を捉えた「スナップ部門」。<br>
                    旅に出たくなるような写真に"旅に出たくなる"キャッチフレーズを添えた「ポスター部門」。<br>
                    そして、ポートレート写真で“あなたの世界“を表現した「ポートレート部門」。<br>
                    受賞者それぞれが自由に表現した世界を、ぜひご覧ください！<br>
                    <a href="/organizer/twitter">Twitterフォトコンテスト受賞作品はこちら</a>
                  </p>
                </div>
              </div><!-- /inner2-->
            </section><!-- /updateBlock-->

            <section class="updateBlock">
              <div class="inner2">
                <h2>2021年11月12日：東京カメラ部2021写真展メッセージ「石川由依」篇 を公開しました。</h2>
                <div class="updateBlockInner">
                  <p class="updateMessage">２年連続でオンライン開催となってしまった今年はその想いを、より広く、より深く皆様にお伝えするために動画を作成いたしました。先日公開させていただいた、梶裕貴さん篇に続いて、第15回声優アワード主演女優賞を受賞された実力派人気声優・石川由依さんにナレーションをご担当いただきました。その実力と魅力的な声で語られるメッセージを通じて、私どもの開催にかける想いを少しでも感じ取っていただけましたら幸いです。<br>
                  <router-link to="/about">東京カメラ部2021写真展メッセージはこちら</router-link>
                  </p>
                </div>
              </div><!-- /inner2-->
            </section><!-- /updateBlock-->

            <section class="updateBlock">
              <div class="inner2">
                <h2>2021年11月9日：10選2020からのメッセージを公開しました。</h2>
                <div class="updateBlockInner">
                  <p class="updateMessage">10選2020に選ばれたphoto_booooy様と、恒松泰至様からの動画メッセージを公開しました。<br>
                  <a href="/#t10s2020">10選2020からのメッセージはこちら</a>
                  </p>
                </div>
              </div><!-- /inner2-->
            </section><!-- /updateBlock-->

            <section class="updateBlock">
              <div class="inner2">
                <h2>2021年11月4日：東京カメラ部2021写真展メッセージ「梶裕貴」篇 を公開しました。</h2>
                <div class="updateBlockInner">
                  <p class="updateMessage">２年連続でオンライン開催となってしまった今年はその想いを、より広く、より深く皆様にお伝えするために動画を作成いたしました。また、その動画のナレーションには、声優アワード主演男優賞受賞を史上初2年連続で受賞された実力派人気声優・梶裕貴さんにご参加いただきました。梶裕貴さんの心のこもったナレーションを通じて、私どもの開催にかける想いを少しでも感じ取っていただけましたら幸いです。<br>
                  <router-link to="/about">東京カメラ部2021写真展メッセージはこちら</router-link>
                  </p>
                </div>
              </div><!-- /inner2-->
            </section><!-- /updateBlock-->

            <section class="updateBlock">
              <div class="inner2">
                <h2>2021年11月3日：「東京カメラ部2021写真展 Online Exhibition」開幕いたしました。</h2>
                <div class="updateBlockInner">
                  <p class="updateMessage"></p>
                </div>
              </div><!-- /inner2-->
            </section><!-- /updateBlock-->

<!-- 去年のアップデート情報の内容を参考までにコメントで保持 -->
<!--
            <section v-if="isClose()" class="updateBlock">
              <div class="inner2">
                <h2>2020年11月1日：「東京カメラ部2020写真展 Online Exhibition」閉幕いたしました。</h2>
                <div class="updateBlockInner">
                  <p class="updateMessage">「東京カメラ部2020写真展 Online Exhibition」へ多くのアクセスをいただき、誠にありがとうございました。本写真展は2020年10月31日をもって終了しました。<br>
                  <span>写真展終了に伴い「応援メッセージ・感想」へのコメント受付は終了となります</span>。
                  今までに皆様から寄せられたコメントや、展示作品、ポートフォリオについては引き続き閲覧可能です。オンライントークショーについてもアーカイブ動画やレポートページを用意していますので、引き続き本サイトをお楽しみください。
                  </p>
                </div>
              </div>
            </section>

            <section class="updateBlock">
              <div class="inner2">
                <h2>2020年10月12日：サイトアップデート（ver1.2）を行いました。</h2>
                <h3>1）オンライントークショーの表示形式の変更</h3>
                <div class="updateBlockInner">
                  <p><router-link to="/talkshows">オンライントークショーのスケジュールページとアーカイブページを統合</router-link>しました。</p>
                  <ul>
                    <li>ライブ配信中のトークショーには「ON AIR」マークと配信ページへのリンクボタンを表示</li>
                    <li>配信終了したトークショーには「配信終了」マークとライブ配信のアーカイブ動画（YouTube）へのリンクボタンを表示</li>
                    <li>トークショーレポートがある場合はトークショーレポートへのリンクボタンを表示</li>
                  </ul>
                </div>

                <h3>2）応援メッセージ・感想の機能変更</h3>
                <div class="updateBlockInner">
                  <p>応援メッセージ・感想のコメント入力機能に入力内容の確認画面を追加しました。</p>
                  <p>応援メッセージ・感想のコメント入力機能のデザインを変更しました。</p>
                </div>

                <h3>3）日本写真100景フォトスポットサイトの紹介を追加</h3>
                <div class="updateBlockInner">
                  <p>日本写真100景フォトスポットサイトの紹介文とリンクボタンを追加しました。</p>
                  <ul>
                    <li><router-link to="/">トップページ</router-link>の作品展示「日本写真100景」メニュー箇所</li>
                    <li><router-link to="/artworks/Japan100Views">作品展示「日本写真100景」トップページ</router-link>の最下部。</li>
                  </ul>
                </div>

                <h3>4）アップデート情報の掲載</h3>
                <div class="updateBlockInner">
                  <p>サイトの機能やページなどの追加・更新情報を掲載する「アップデート情報」ページ（このページ）を新たに追加しました。</p>
                </div>

                <h3>5）トップページお知らせエリアの追加</h3>
                <div class="updateBlockInner">
                  <p><router-link to="/">トップページ</router-link>にサイトからのお知らせを表示するエリアを新たに追加しました。</p>
                </div>

                <h3>6）スマートフォン用メインメニューボタン位置の変更</h3>
                <div class="updateBlockInner">
                  <p>スマートフォンでの閲覧時に表示されるメインメニューボタン位置を左側に変更しました。</p>
                </div>

              </div>
            </section>

            <section class="updateBlock last">
              <div class="inner2">

                <h2>2020年9月29日：サイトアップデート（ver1.1）を行いました。</h2>

                <h3>1）ヘッダメニューの変更</h3>
                <div class="updateBlockInner">
                  <h4>名称の変更</h4>
                  <p>以下の名称を変更いたしました。</p>
                  <ul>
                    <li>「オンライン作品展示」を「作品展示」に変更</li>
                    <li>「オンライン特別展示」を「特別展示」に変更</li>
                  </ul>

                  <h4>作品展示の階層化</h4>
                  <p>東京カメラ部10選、日本写真100景、"My Precious" Photo Contestにサブメニューを用意しました。</p>
                  <ul>
                    <li>東京カメラ部10選：年度別のサブメニュー</li>
                    <li>日本写真100景：エリア別のサブメニュー</li>
                    <li>"My Precious" Photo Contest：部門別のサブメニュー</li>
                  </ul>
                  <p class="attentionUl">サブメニューをクリックで該当の箇所の最初の展示者ページへ移動します。</p>
                  <h4>スマートフォン向けメニューの変更</h4>
                  <p>上記の修正に合わせて、スマートフォンメニューも変更いたしました。</p>
                </div>

                <h3>2）作品展示 トップページの変更</h3>
                <div class="updateBlockInner">
                  <p><router-link to="/artworks">東京カメラ部10選、日本写真100景、"My Precious" Photo
                      Contestのサブメニューを表示したトップページ</router-link>に変更いたしました。</p>
                  <p class="attention">※旧トップページは「<router-link to="/exhibitors">展示者一覧</router-link>」として別途設置</p>
                </div>

                <h3>3）作品展示 カテゴリー別トップページの追加</h3>
                <div class="updateBlockInner">
                  <p><router-link to="/artworks/Tcc10Sen">東京カメラ部10選</router-link>、<router-link to="/artworks/Japan100Views">日本写真100景</router-link>、<router-link to="/artworks/MyPrecious">"My Precious" Photo Contest</router-link>
                      それぞれにカテゴリートップページを新たに追加いたしました。</p>
                  <ul>
                    <li>各トップページでは、作品サムネイル画像と展示者名を掲載しています。</li>
                    <li>サムネイルまたは展示者名をクリックで各人の展示ページへ移動します。</li>
                  </ul>
                  <p class="attentionUl">※日本100景のみは都道府県名も掲載。</p>
                </div>

                <h3>4）作品展示ページのスワイプ機能の変更</h3>
                <div class="updateBlockInner">
                  <p>東京カメラ部10選、日本写真100景、"My Precious" Photo Contest内でループするように変更いたしました。</p>
                </div>

              </div>
            </section>
-->
          </div><!-- /updateInfoBody-->
        </section><!-- /updateInfo-->
      </div><!-- /main-->
    </div>
    <Footer />
    <div class="actionMenu">
      <UpButton />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Header from '@/components/modules/Header.vue'
import Footer from '@/components/modules/Footer.vue'
import enumMixin from '@/concern/enumMixin'
import constMixin from '@/concern/constMixin'
import UpButton from '@/components/modules/UpButton.vue'
import moment from 'moment-timezone'

export default {
  mixins: [enumMixin, constMixin], // Enum値, const値の読み込み
  components: {
    Header,
    Footer,
    UpButton
  },
  data () {
    return {
      timerId: null,
      nowDateTime: null
    }
  },
  computed: {
    ...mapGetters(['winners', 'winnersByAwardType', 'areas'])
  },
  methods: {
    // 写真展オープン中か、本番環境以外の場合、フラグにtrueを設定
    checkOpenExhibition () {
      // UNIXタイムスタンプの現在時
      const now = new Date().getTime() / 1000
      return (now <= 1639234799)
    },
    setTitleAndDescription (to) {
      document.title = to.meta.title ? to.meta.title : ''
      document
        .querySelector('meta[name="description"]')
        .setAttribute('content', to.meta.desc ? to.meta.desc : '')
    },
    // 現在時刻のセット
    setNow () {
      this.nowDateTime = moment().tz('Asia/Tokyo').format('YYYYMMDD HH:mm:ss')
      this.timerId = setInterval(function () {
        this.nowDateTime = moment().tz('Asia/Tokyo').format('YYYYMMDD HH:mm:ss')
      }.bind(this), 1000)
    },
    isClose () {
      return true
      // return (this.nowDateTime > '20201031 23:59:59')
    }
  },
  created () {
    this.setNow()
  },
  beforeDestroy () {
    clearInterval(this.timerId)
  },
  mounted () {
    // titleとdescriptionの設定
    this.setTitleAndDescription(this.$route)
  },
  watch: {
    $route: function (to, from) {
      this.setTitleAndDescription(to)
    }
  }
}
</script>

<style scoped>
</style>
